import { defineComponent, ref, reactive, watch, computed } from "vue";
import { definePropType } from "@types-vue/props";
import { RatioType } from "video-editor-renderer";
import VideoPlay from "@pt/views/pt-entry/components/video-player/index.vue";
import { getImgHeight } from "@ve-pro/ve/aside/modular/template-modular/components/index";
import _ from "lodash";
var DefaultLang;
(function(DefaultLang) {
    DefaultLang[""] = "\u539F\u8BED\u8A00";
})(DefaultLang || (DefaultLang = {}));
export default defineComponent({
    components: {
        VideoPlay: VideoPlay
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        row: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleClickCard = function handleClickCard(card) {
            activeCard.value = card.name;
            init();
        };
        var reloadVideo = function reloadVideo() {
            var player = videoPlayRef.value;
            var videoEl = player === null || player === void 0 ? void 0 : player.videoRef;
            if (videoEl) {
                player.handlePause();
                player.progressVal = 0;
                videoEl.load();
                player.loading = true;
            }
        };
        var getPreviewUrl = // 预览链接
        function getPreviewUrl(url) {
            if (activeLanguage.value === DefaultLang[""]) {
                // @ts-ignore
                preview_url.value = url[""][activeRatio.value];
            } else {
                // @ts-ignore
                preview_url.value = url[activeLanguage.value][activeRatio.value];
            }
        };
        var init = function init() {
            activeLanguage.value = String(languageGroup.value[0]);
            activeRatio.value = ratioGroup.value[0];
            if (!_.isNull(getUrl.value)) {
                getPreviewUrl(getUrl.value);
            }
        };
        var activeCard = ref("");
        var activeLanguage = ref("");
        var preview_url = ref("");
        var activeRatio = ref(RatioType["9:16"]);
        var videoPlayRef = ref();
        var defaultCardList = reactive([
            {
                label: "\u89C6\u9891",
                value: "video"
            },
            {
                label: "\u56FE\u7247",
                value: "image"
            }, 
        ]);
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        // 封面
        var cover_previews = computed(function() {
            if (JSON.stringify(props.row.cover_previews) !== "{}") {
                return props.row.cover_previews;
            }
            return null;
        });
        // 视频
        var previews = computed(function() {
            if (JSON.stringify(props.row.previews) !== "{}") {
                return props.row.previews;
            }
            return null;
        });
        // 视频、图片tab
        var cardList = computed(function() {
            if (!_.isNull(cover_previews.value) && !_.isNull(previews.value)) {
                return defaultCardList;
            } else if (!_.isNull(previews.value)) {
                return defaultCardList.slice(0, 1);
            } else if (!_.isNull(cover_previews.value)) {
                return defaultCardList.slice(1, 2);
            }
            return [];
        });
        var getUrl = computed(function() {
            return activeCard.value === "video" ? previews.value : cover_previews.value;
        });
        // 视频、图片下的语言tab
        var languageGroup = computed(function() {
            var languageList = [];
            // 视频下的语言
            if (activeCard.value === "video") {
                if (!_.isNull(previews.value)) {
                    languageList = Object.keys(previews.value);
                }
            // 封面下的语言
            } else if (activeCard.value === "image") {
                if (!_.isNull(cover_previews.value)) {
                    languageList = Object.keys(cover_previews.value);
                }
            }
            return languageList.length && languageList.map(function(t) {
                return t === "" ? DefaultLang[t] : t;
            }) || [];
        });
        // 语言下对应的比例
        var ratioGroup = computed(function() {
            if (activeCard.value === "video") {
                if (!_.isNull(previews.value)) {
                    return activeLanguage.value === DefaultLang[""] ? Object.keys(previews.value[""]) : Object.keys(previews.value[activeLanguage.value]);
                } else {
                    return [];
                }
            } else if (activeCard.value === "image") {
                if (!_.isNull(cover_previews.value)) {
                    return activeLanguage.value === DefaultLang[""] ? Object.keys(cover_previews.value[""]) : Object.keys(cover_previews.value[activeLanguage.value]);
                } else {
                    return [];
                }
            }
            return [];
        });
        // 切换语言
        var handleChangeLanguage = function(lang) {
            reloadVideo();
            activeLanguage.value = lang;
            activeRatio.value = ratioGroup.value[0];
            if (!_.isNull(getUrl.value)) {
                getPreviewUrl(getUrl.value);
            }
        };
        // 比例切换
        var handleChangeRadio = function(item) {
            reloadVideo();
            activeRatio.value = item;
            if (!_.isNull(getUrl.value)) {
                getPreviewUrl(getUrl.value);
            }
        };
        var handleClose = function() {
            emit("update:visible", false);
        };
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                activeCard.value = cardList.value && cardList.value.length ? cardList.value[0].value : "";
                init();
            }
        });
        return {
            cardList: cardList,
            activeCard: activeCard,
            videoPlayRef: videoPlayRef,
            preview_url: preview_url,
            activeRatio: activeRatio,
            activeLanguage: activeLanguage,
            languageGroup: languageGroup,
            ratioGroup: ratioGroup,
            dialogVisible: dialogVisible,
            getImgHeight: getImgHeight,
            handleClose: handleClose,
            handleClickCard: handleClickCard,
            handleChangeRadio: handleChangeRadio,
            handleChangeLanguage: handleChangeLanguage
        };
    }
});
